import { render, staticRenderFns } from "./TablePopup2Item.vue?vue&type=template&id=5f6f5047&scoped=true"
import script from "./TablePopup2Item.vue?vue&type=script&lang=js"
export * from "./TablePopup2Item.vue?vue&type=script&lang=js"
import style0 from "./TablePopup2Item.vue?vue&type=style&index=0&id=5f6f5047&scoped=true&lang=css"
import style1 from "./TablePopup2Item.vue?vue&type=style&index=1&id=5f6f5047&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6f5047",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f6f5047')) {
      api.createRecord('5f6f5047', component.options)
    } else {
      api.reload('5f6f5047', component.options)
    }
    module.hot.accept("./TablePopup2Item.vue?vue&type=template&id=5f6f5047&scoped=true", function () {
      api.rerender('5f6f5047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/tableItems/TablePopup2Item.vue"
export default component.exports